import { Router } from '@angular/router';
var CasesComponent = /** @class */ (function () {
    function CasesComponent(router) {
        this.router = router;
        this.expedientes = [];
        this.loading = false;
        this.skeletonSlots = [0, 1, 2];
    }
    Object.defineProperty(CasesComponent.prototype, "items", {
        get: function () {
            return (this.expedientes || []).slice(0, 3);
        },
        enumerable: true,
        configurable: true
    });
    CasesComponent.prototype.irA = function (link) {
        this.router.navigate([link]);
    };
    /**
     * Solo el asegurado del expediente puede ver el detalle y escribir al tramitador. Ante la
     * duda (dato ausente) se oculta: es preferible que un tomador legitimo tenga que llamar a
     * que alguien vea un expediente de otra persona.
     */
    CasesComponent.prototype.puedeOperar = function (expediente) {
        return !!expediente && expediente.esAseguradoEnExpediente === true;
    };
    CasesComponent.prototype.irDetalle = function (expediente) {
        // Guarda defensiva: la plantilla ya oculta los botones, pero la navegacion no debe
        // depender solo de eso.
        if (!this.puedeOperar(expediente)) {
            return;
        }
        var ruta = this.eventRoute(expediente);
        this.router.navigate(ruta || ['/events']);
    };
    CasesComponent.prototype.irTramitador = function (expediente) {
        if (!this.puedeOperar(expediente)) {
            return;
        }
        var ruta = this.eventRoute(expediente);
        this.router.navigate(ruta ? ruta.concat(['messenger']) : ['/contact/form']);
    };
    CasesComponent.prototype.eventRoute = function (expediente) {
        var ref = (expediente && expediente.expedienteNumero || '').toString().trim();
        if (!ref) {
            return null;
        }
        return ['/event', ref];
    };
    CasesComponent.prototype.tagClass = function (estado) {
        var e = (estado || '').toLowerCase();
        if (e === 'cerrado')
            return 'tag-cerrado';
        if (e === 'abierto')
            return 'tag-abierto';
        return 'tag-en-curso';
    };
    return CasesComponent;
}());
export { CasesComponent };
